// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { listStyles } from "@rpsc/Overrides/Widgets/ProductList/ProductListCardList";
import { color, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

listStyles.wrapper = {};

listStyles.cardList = {
    gridContainer: {
        gap: 22,
        css: css`
            ${xScreen("lte", "sm")} {
                border-bottom: none;
            }
            &[data-test-selector="productListCards_List"] {
                padding-bottom: 12px;
                border-bottom: 1px solid ${getColor("common.border")};
                ${xScreen("lte", "md")} {
                    padding-bottom: 24px;
                }

                & > div {
                    margin-top: 0;
                    ${xScreen("lte", "sm")} {
                        justify-content: center;
                    }
                }
            }
            &[data-test-selector="productListCards_Grid"] {
                border-bottom: 1px solid ${color("common.border")};
                padding-bottom: 24px;
                & > div {
                    margin-top: 0;
                }
            }
        `,
    },
};

listStyles.cardContainerStyles = {
    cardDivider: {
        css: css`
            border: none;
            margin: 0;
            width: 100%;
            padding: 0;
            border-bottom: 1px solid ${color("common.border")};
            &:last-child {
                border-bottom: 0;
            }
            ${xScreen("lte", "md")} {
                width: 50%;
                border-radius: 4px;
                padding: 12px;
                border: none;
            }
            ${xScreen("lte", "sm")} {
                width: 100%;
                max-width: 358px;
                margin: 0 12px;
                padding: 16px 0;
                border-bottom: 1px solid ${color("common.border")};
                border-radius: 0;
                &:first-child {
                    padding-top: 12px;
                }
            }
            ${xScreen("lte", "xs")} {
                max-width: 100%;
            }
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            ${xScreen("lte", "md")} {
                height: 100%;
                padding: 0;
            }
        `,
    },
};
listStyles.cardContainerMultiColumnStyles = {
    cardDivider: {
        css: css`
            border: none;
            height: 100%;
            padding: 0;
        `,
    },
    gridItem: {
        width: [12, 12, 6, 4, 4],
        css: css`
            padding: 11px;
            ${xScreen("lte", "md")} {
                &:nth-child(2n) {
                    justify-content: flex-end;
                }
            }
            ${xScreen("lte", "sm")} {
                &:nth-child(2n) {
                    justify-content: flex-start;
                }
            }
        `,
    },
};

listStyles.zeroResultsWrapper = {
    css: css`
        height: auto;
        margin: 48px 0;
        .questions-widget-wrapper {
            height: 100%;
        }
    `,
};
